export default [
    {
        path: "/shop/",
        name: "home",
        meta: { auth: true, home: true }
    },
    {
        path: "/shop/login",
        name: "login",
        component: require("../views/Auth/Login").default
    },
    {
        path: "/shop/forgotpassword/token/:token",
        name: "forgotpassword",
        component: require("../views/Auth/ForgotPassword").default
    },
    {
        path: "/shop/register",
        name: "register",
        component: require("../views/Auth/Register").default
    },
    {
        path: "/shop/online-application-form",
        name: "onlineapplication",
        component: require("../views/RegisterApplication.vue").default
    },
    {
        path: "/shop/thank-you-for-applying",
        name: "thankyou-applying",
        component: require("../views/ThankyouOnline").default,
    },
    {
        path: "/shop/account",
        name: "account",
        component: require("../views/Admin/Account").default,
        meta: { auth: true }
    },
    {
        path: "/shop/orders",
        name: "orders",
        component: require("../views/Admin/Orders").default,
        meta: { auth: true }
    },
    {
        path: "/shop/fauxfur",
        name: "fauxfur",
        beforeEnter(to, from, next) {
            window.location.replace("/")
        }
    },
    {
        path: "/shop/pricesheet",
        name: "pricesheet",
        component: require("../views/Admin/Pricesheet").default,
        meta: { auth: true }
    },
    {
        path: "/shop/singleorder/:salesid",
        name: "singleorder",
        component: require("../views/Admin/SingleOrder").default,
        meta: { auth: true }
    },
    {
        path: "/shop/singleorderhold/:salesid",
        name: "singleorderhold",
        component: require("../views/Admin/SingleOrderHold").default,
        meta: { auth: true }
    },
    {
        path: "/shop/invoices",
        name: "invoices",
        component: require("../views/Admin/Invoices").default,
        meta: { auth: true }
    },
    {
        path: "/shop/projects",
        name: "projects",
        component: require("../views/Admin/Projects").default,
        //meta: { auth: false, home: false }
    },
    {
        path: "/shop/products/fabric",
        name: "productfilter",
        component: require("../views/ProductFilter").default,
        //meta: { auth: false, home: false }
    },
	{
        path: "/shop/products/hardware",
        name: "productshardware",
        component: require("../views/ProductFilterHardware").default,
        //meta: { auth: false, home: false }
    },
	{
        path: "/shop/products/trim",
        name: "productstrim",
        component: require("../views/ProductFilterTrim").default,
        //meta: { auth: false, home: false }
    },
    {
        path: "/shop/products/sample",
        name: "productssample",
        component: require("../views/ProductFilterSample").default,
        //meta: { auth: false, home: false }
    },
    {
        path: "/shop/collections/fabric",
        name: "collectionfilter",
        component: require("../views/CollectionFilter").default,
    },
    {
        path: "/shop/collections/trim",
        name: "collectionfiltertrim",
        component: require("../views/CollectionFilterTrim").default,
    },
    {
        path: "/shop/product/:itemid/:inventcolorid",
        name: "product",
        component: require("../views/Product").default,
    },
    {
        path: "/shop/hardware/:itemid/:inventcolorid",
        name: "hardwareproduct",
        component: require("../views/ProductHardware").default,
    },
    {
        path: "/shop/sample/:itemid",
        name: "sampleproduct",
        component: require("../views/ProductSample").default,
    },
    {
        path: "/shop/cart",
        name: "cart",
        component: require("../views/Cart").default,
        meta: { auth: true}
    },
    {
        path: "/shop/checkout",
        name: "checkout",
        component: require("../views/Checkout").default,
        meta: { auth: true}
    },
    {
        path: "/shop/thankyou/:order_id",
        name: "thankyou",
        component: require("../views/Thankyou").default,
        meta: { auth: true }
    },
    {
        path: "/shop/search/:term",
        name: "productsearch",
        component: require("../views/ProductSearch").default,
    },
    {
        path: "/shop/impersonate-account",
        name: "productsearch",
        component: require("../views/Admin/ImpersonateAccount").default,
        meta: { auth: true }
    },
    {
        path: "/shop/contact",
        name: "contact",
        component: require("../views/Contact").default,
        //meta: { auth: false, home: false }
    },
    {
        path: "/shop/promo",
        name: "promo",
        component: require("../views/Promo").default,
        meta: { auth: true}
    },
    {
        path: "/shop/sheer-by-the-inch",
        name: "sheer",
        component: require("../views/Sheer").default,
        meta: { auth: true}
    },
    {
        path: "/shop/pleated-drapery",
        name: "PleatedDrapery",
        component: require("../views/PleatedDrapery").default,
        meta: { auth: true}
    },
    {
        path: "/shop/quick-ship",
        name: "quickship",
        component: require("../views/QuickShip").default,
        meta: { auth: true}
    },
    {
        path: "/shop/quick-ship/update/:id",
        name: "quickship-update",
        component: require("../views/QuickShip").default,
        meta: { auth: true}
    },
    {
        path: "/shop/promo/update/:id",
        name: "promo-update",
        component: require("../views/Promo").default,
        meta: { auth: true}
    },
    {
        path: "/shop/sheer-by-the-inch/update/:id",
        name: "sheer-update",
        component: require("../views/Sheer").default,
        meta: { auth: true}
    },
    {
        path: "/shop/pleated-drapery/update/:id",
        name: "PleatedDrapery-update",
        component: require("../views/PleatedDrapery").default,
        meta: { auth: true}
    },
    {
        path: "/shop/custom-print-image-upload",
        name: "custom-print-image-upload",
        component: require("../views/CustomPrintImageUpload").default,
        meta: { auth: true}
    },
    {
        path: "/shop/custom-print-image-upload/:id",
        name: "custom-print-image-upload-update",
        component: require("../views/CustomPrintImageUploadUpdate").default,
        meta: { auth: true}
    },
    // 404
    {
        path: "*",
        redirect: "/shop/404"
    },
    {
        path: "/shop/404",
        name: "404",
        component: require("../views/Errors/NotFound.vue").default
    }
];